<div class="w-full pb-4 mb-8 border-b border-gray-300 font-light text-lg">
  <ng-content></ng-content>
</div>
